import {
    Box,
    Flex,
    HStack,
    Skeleton,
    SkeletonCircle,
    VStack,
} from "@chakra-ui/react";

const skeletonProps = {
    bg: "#DAE9FF",
    borderRadius: "md",
};

export default function NotificationModalSkeleton() {
    return (
        <VStack
            align="stretch"
            gap={0}
        >
            {Array.from({ length: 5 }).map((_, index) => (
                <Flex
                    key={index}
                    p={{
                        base: 4,
                        md: 6,
                    }}
                    gap={4}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                    bg="white"
                >
                    <SkeletonCircle
                        bg="#DAE9FF"
                        size="11"
                    />

                    <Box flex="1">
                        <Flex
                            justify="space-between"
                            align="center"
                            mb={3}
                            gap={4}
                        >
                            <Skeleton
                                {...skeletonProps}
                                h="12px"
                                w="90px"
                            />

                            <Skeleton
                                {...skeletonProps}
                                h="12px"
                                w="80px"
                            />
                        </Flex>

                        <Skeleton
                            {...skeletonProps}
                            h="18px"
                            w="70%"
                            mb={3}
                        />

                        <Skeleton
                            {...skeletonProps}
                            h="12px"
                            w="100%"
                            mb={2}
                        />

                        <Skeleton
                            {...skeletonProps}
                            h="12px"
                            w="90%"
                        />
                    </Box>
                </Flex>
            ))}
        </VStack>
    );
}